var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio-group',{attrs:{"hide-details":"","row":""},model:{value:(_vm.selectedGrade),callback:function ($$v) {_vm.selectedGrade=$$v},expression:"selectedGrade"}},_vm._l((_vm.grades),function(grade,index){return _c('v-radio',{key:index,attrs:{"label":grade.text,"value":grade.value,"disabled":grade.disabled,"color":"secondary"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }